/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useRef, useState } from 'react';
import StoryblokClient from 'storyblok-js-client';
import { StoryblokService } from '../../services';
import { AnyProps } from '../types';

export const RocheHotspotImage = ({ blok }: AnyProps): JSX.Element => {
  const allHotspots = blok.hotspots_slot;
  let dynamicHotspots = allHotspots.filter((h) => h.component === 'hotspot-icon-dynamic');
  const staticHotspots = allHotspots.filter((h) => h.component === 'hotspot-icon-static');
  const storyblokJsClient = useRef(null);
  const [hotspots, setHotspots] = useState([]);
  const getTeaserData = async (): Promise<void> => {
    let teasers = [];
    if (dynamicHotspots && dynamicHotspots.length > 0) {
      const { data } = await storyblokJsClient.current?.getStories({
        by_uuids: dynamicHotspots.map((p) => p.page).join(','),
      });
      teasers = data.stories.reduce((acc, val) => ({
        ...acc,
        [val.uuid]: {
          text: val.content.teaser_text,
          title: val.content.teaser_title,
          link_slot: [
            {
              link: { url: `/${val.full_slug}` },
              target: '_blank',
              icon: 'chevron-right',
              text: null,
            },
          ],
        },
      }), {});
      dynamicHotspots = dynamicHotspots.map((d) => {
        teasers[d.page].link_slot[0].text = d.link_text;
        return {
          ...d,
          ...teasers[d.page],
        };
      });
    }
    setHotspots([...staticHotspots, ...dynamicHotspots]);
  };

  useEffect(() => {
    storyblokJsClient.current = new StoryblokClient({
      accessToken: StoryblokService.getConfig().options.accessToken as string,
    });
    setHotspots(staticHotspots);
    getTeaserData();
  }, []);

  return React.createElement('roche-hotspot-image', {
    image: JSON.stringify(blok.image_slot),
    hotspots: JSON.stringify(hotspots),
    'hide-spots-mobile': blok.hide_spots_mobile,
    'hide-component-mobile': blok.hide_component_mobile,
  });
};
